import { HealthGoalTypesType } from 'components/molecules/HealthGoalSelection/HealthGoalSelection';
import axios from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';
import { ProfileDataType } from 'store/profile';
import { AllergyType, NutritionPhilosophyType } from '../types/DietaryHabits';

export const getUserData = () => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles`;

	return axios.get(requestUrl);
};

export const getUserFilters = () => {
	const requestURL = `${appConfig.env.urlSpringAPI}/profiles/filters`;

	return axios.get(requestURL);
};

export const setUserFilter = (filterKey: string, filterValue: string) => {
	const requestURL = `${appConfig.env.urlSpringAPI}/profiles/filters`;

	return axios.post(requestURL, {
		[filterKey]: filterValue,
	});
};

export const selectCoach = (data: { coach: string }) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/coach/${data.coach}`;
	return axios.put(requestUrl);
};

export const selectGender = (data: { gender: string; isPregnant?: boolean; acceptedWarnHint?: boolean }) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/gender`; // TODO
	const params = {
		gender: data.gender,
		pregnant: !!data.isPregnant,
		tempPregnant: !!data.isPregnant,
		acceptedPregnancyWarning: !!data.acceptedWarnHint,
		tempAcceptedPregnancyWarning: !!data.acceptedWarnHint,
	};

	return axios.put(requestUrl, params);
};

export const setDsgvo = (data: { dsgvo: boolean }) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/dsgvo/${data.dsgvo ? 'TRUE' : 'FALSE'}`;
	return axios.put(requestUrl);
};

export const setBirthdate = (data: Object) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/birthdate`;
	return axios.put(requestUrl, data);
};

export const setParticipateCompetition = (data: { participate: boolean; programId: string }) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/programs/${data.programId}/competition?participate=${data.participate}`;
	return axios.put(requestUrl);
};

export const setHeight = (data: { acceptedHeightWarning?: boolean; height: number }) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/height`;

	data.acceptedHeightWarning = !!data.acceptedHeightWarning;
	data.height = data.height || -1;

	return axios.put(requestUrl, data);
};

export const setWeight = (data: { acceptedWeightWarning?: boolean; weight: number }) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/weight`;

	data.acceptedWeightWarning = !!data.acceptedWeightWarning;
	data.weight = data.weight || -1;

	return axios.put(requestUrl, data);
};

export const setHealthTarget = (data: Object) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/healthgoal`;
	return axios.put(requestUrl, data);
};

export type RequestSetTempHealthTarget = { selectedHealthGoal: HealthGoalTypesType };
export type ResponseSetTempHealthTargetData = ProfileDataType;
export type ResponseSetTempHealthTarget = { data: ResponseSetTempHealthTargetData; actions: any[] };
export const setTempHealthTarget = (data: RequestSetTempHealthTarget) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/temphealthgoal/${data.selectedHealthGoal}`;
	return axios.put<ResponseSetTempHealthTarget>(requestUrl);
};

export const setActivityLevel = (data: { intensity: number }) => {
	if (!data || !data.intensity || isNaN(data.intensity)) {
		throw new Error(`Invalid intensity received from React: ${data.intensity.toString() || '<undefined>'}`);
	}

	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/intensity/${data.intensity}`;

	return axios.put(requestUrl);
};

export const setDietaryHabits = (data: { nutritionPhilosophy: NutritionPhilosophyType; allergies: AllergyType }) => {
	if (!data || !data.nutritionPhilosophy || !data.allergies) {
		throw new Error(
			`Invalid dietary habits received from React: ${data.nutritionPhilosophy.toString()}, ${data.allergies.toString()}`
		);
	}
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/dietaryhabits`;

	return axios.put(requestUrl, data);
};

export const finish = () => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/finish`;

	return axios.put(requestUrl);
};

export const putSlogan = (slogan: string): Object | void => {
	const requestURL = `${appConfig.env.urlSpringAPI}/profiles/slogan`;
	return axios.put(requestURL, {
		slogan,
	});
};

export const finishOnboarding = () => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/finishOnboarding`;
	return axios.put(requestUrl);
};

export const updateSettings = (settings: Object = {}) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/settings`;
	return axios.post(requestUrl, settings);
};
